import React from "react";

const BackgroundOverlay = () => {
  return (
    <div className="absolute inset-0 w-full h-full rounded-lg z-1 bg-gradient-to-t from-black via-black/85 to-black/0" />
  );
};

export default BackgroundOverlay;
